export default __webpack_public_path__ + "static/media/1927.45219631.png";